function isOnlyInvestor (user) {
  if (!user || !user.roles) {
    return false
  }
  const hasInvestor = user.roles.some(function (role) {
    return role.name === 'investor'
  })
  const hasHigherRole = user.roles.some(function (role) {
    return ['superadmin', 'admin', 'staff'].indexOf(role.name) !== -1
  })
  return hasInvestor && !hasHigherRole
}

module.exports = {
  isOnlyInvestor
}
